import api from './api';

class RoleService {
  // Obtener todos los roles
  async getAll() {
    try {
      const response = await api.get('/auth/roles');
      return response.data;
    } catch (error) {
      console.error('Error al obtener roles:', error);
      throw error;
    }
  }

  // Obtener un rol por ID
  async getById(id) {
    try {
      const response = await api.get(`/auth/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener rol:', error);
      throw error;
    }
  }

  // Crear nuevo rol
  async create(roleData) {
    try {
      const response = await api.post('/auth/roles', roleData);
      return response.data;
    } catch (error) {
      console.error('Error al crear rol:', error);
      throw error;
    }
  }

  // Actualizar rol
  async update(id, roleData) {
    try {
      const response = await api.put(`/auth/roles/${id}`, roleData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar rol:', error);
      throw error;
    }
  }

  // Eliminar rol
  async delete(id) {
    try {
      const response = await api.delete(`/auth/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar rol:', error);
      throw error;
    }
  }

  // Obtener menús asignados a un rol
  async getRoleMenus(roleId) {
    try {
      const response = await api.get(`/auth/roles/${roleId}/menus`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener menús del rol:', error);
      throw error;
    }
  }

  // Actualizar menús asignados a un rol
  async updateRoleMenus(roleId, menuIds) {
    try {
      const response = await api.put(`/auth/roles/${roleId}/menus`, {
        menuIds
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar menús del rol:', error);
      throw error;
    }
  }

  // Obtener todos los menús disponibles
  async getAllMenus() {
    try {
      const response = await api.get('/auth/menus');
      return response.data;
    } catch (error) {
      console.error('Error al obtener menús:', error);
      throw error;
    }
  }

  // Copiar configuración de menús de un rol a otro
  async copyRoleMenus(fromRoleId, toRoleId) {
    try {
      const response = await api.post(`/auth/roles/${toRoleId}/menus/copy`, {
        fromRoleId
      });
      return response.data;
    } catch (error) {
      console.error('Error al copiar menús:', error);
      throw error;
    }
  }

  // Obtener estadísticas de asignación de menús
  async getMenuStats() {
    try {
      const response = await api.get('/auth/roles/menu-stats');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
      throw error;
    }
  }

  // Asignar usuarios a un rol
  async assignUsersToRole(roleId, userIds) {
    try {
      const response = await api.post(`/auth/roles/${roleId}/users`, {
        userIds
      });
      return response.data;
    } catch (error) {
      console.error('Error al asignar usuarios al rol:', error);
      throw error;
    }
  }

  // Obtener usuarios de un rol
  async getRoleUsers(roleId) {
    try {
      const response = await api.get(`/auth/roles/${roleId}/users`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuarios del rol:', error);
      throw error;
    }
  }
}

const roleService = new RoleService();
export { roleService };
export default roleService; 